import { useState } from "react";
import { homeService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { IBidOptionResponse, IBidPricingResponse } from "@miplatform/types";

export const useOptionPriceDetailsDrawerViewModel = () => {
  const [priceDetails, setPriceDetails] = useState<IBidPricingResponse | null>(
    null
  );

  const getPriceDetails = async (
    builderId: string,
    option: IBidOptionResponse
  ) => {
    const response = await homeService.pricing.options.getById({
      planAreas: option.planAreas,
      accountId: builderId,
    });
    if (response.status === HTTP_STATUSES.OK) {
      setPriceDetails(response.data.planDetails);
    }
  };

  return {
    priceDetails,
    getPriceDetails,
  };
};
